export default {
	service: [
		"Szolgáltatás",
		"Esemény",
		"Kifizetés",
		"Befizetés",
		"ÁSZF",
		"Tanúsítvány",
		"GYIK",
		"Felhasználói Útmutató",
		"VIP"
	],
	sign: {
		title: "{0} napja bejelentkezve",
		SignIn: "Bejelentkezés"
	},
	hotMusicAlbum: "Forró Zenei Album",
	hotMusic: "Forró Dalslágerek",
	popular: "Új lejátszás",
	rankings: "Népszerű filmek",
	top: "TOP{0}",
	OnchainServices: "Onchain szolgáltatások",
	Real: {
		title: "Valós idő",
		list: [
			"Összes online felhasználó",
			"Átlagos felhasználói optimalizálási mennyiség",
			"Optimalizálási igények hőtérképe",
			"Platform promóciós optimalizálási mennyiség"
		]
	},
	work: {
		title: "Megrendelés leadásának jutalma",
		SignIn: "Megkap"
	},
	Profit: {
		Profit: "Nyereség",
		tabs: ["Nyereség", "Bónusz", "Fiók"],
		TotalBalance: "Teljes Egyenleg",
		TotalLuckyBonus: "Teljes Szerencse Bónusz",
		todayEarnings: "Mai Kereset",
		availableBalance: "Elérhető Egyenleg",
		title: ["Mai Kereset", "Teljes Kereset", "Fiók"],
		list: ["Rendelési Kereset", "Csapat Kereset", "Teljes Kereset"],
		order: {
			title: "Rendelési Nyereség",
			commission: "Rendelési Jutalék"
		},
		Analysis: {
			title: "Nyereség Elemzés",
			tips: "{0} tranzakciót hajtott végre",
			tabs: ["Mai Nyereség", "Teljes Nyereség"],
			totalTitle: ["Rendelési Nyereség", "Bejelentkezési Nyereség", "Csapat Nyereség", "Bónusz Nyereség"]
		}
	},
	CustomerService: {
		title: "Ügyfélszolgálati Központ",
		consultation: "Ügyfélszolgálati Konzultáció",
		btn: "Lépjen Kapcsolatba Velünk",
		noticeTitle: "Rendszerértesítés"
	},
	addWallet: "Pénztárca hozzáadása",
	taskProgress: "Napi feladatok előrehaladása",
	currentProgress: "Aktuális feladat előrehaladása",
	awardsBulletin: `{0} felhasználó nyeri a {1} {2} díjat a feladatban.`,
	vip: {
		title: "@:vip.title",
		more: "Többet látni"
	},
	stats: {
		title: "Adatforrások - Irányítópult és API",
		subTitle: "Előadóművészek statisztikái",
		list: ["Mérőszámok", "Aktív közösségi hálózatú előadóművészek", "Naponta frissítve"]
	}
};
